import { render, staticRenderFns } from "./FormDirtyOnLeavePage.vue?vue&type=template&id=63b03880&"
import script from "./FormDirtyOnLeavePage.vue?vue&type=script&lang=ts&"
export * from "./FormDirtyOnLeavePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports